// Тосты (Sonner 2): shadcn 4.21.1 (base-mira), подогнаны под пульт (задача D5, ui-spec §5):
// - тема — тема пульта (`useResolvedTheme`), а не `next-themes` из генератора: этой зависимости в пульте нет;
// - снизу справа, видно не больше трёх, у каждого крестик «Закрыть уведомление»; область — `aria-live="polite"`
//   (так Sonner устроен сам), подпись области — «Уведомления»;
// - цвета и радиус — токены пульта через переменные Sonner (`--normal-*`), шрифт и кегль — как у текста пульта;
//   движение — своё у Sonner (вход и уход тоста, при уменьшенном движении Sonner его выключает сам).
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import type * as React from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useResolvedTheme } from '@/lib/theme';

const STYLE = {
  '--normal-bg': 'var(--popover)',
  '--normal-text': 'var(--popover-foreground)',
  '--normal-border': 'var(--border)',
  '--border-radius': 'var(--radius-lg)',
  '--width': '22.5rem',
  fontFamily: 'var(--font-sans)',
} as React.CSSProperties;

function Toaster({ ...props }: ToasterProps) {
  const theme = useResolvedTheme();
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      visibleToasts={3}
      closeButton
      containerAriaLabel="Уведомления"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon aria-hidden="true" className="size-4 text-st-sales" />,
        info: <InfoIcon aria-hidden="true" className="size-4 text-muted-foreground" />,
        warning: <TriangleAlertIcon aria-hidden="true" className="size-4 text-st-human" />,
        error: <OctagonXIcon aria-hidden="true" className="size-4 text-st-error" />,
        loading: <Loader2Icon aria-hidden="true" className="spin size-4 text-muted-foreground" />,
      }}
      style={STYLE}
      toastOptions={{
        closeButtonAriaLabel: 'Закрыть уведомление',
        // Стили Sonner сильнее классов, поэтому у каждого класса «!» (important в Tailwind 4 — в конце).
        classNames: {
          toast: 'text-base! shadow-pop!',
          title: 'font-medium!',
          description: 'text-sm! text-muted-foreground!',
          actionButton: 'h-7! max-sm:h-10! rounded-md! bg-primary! px-2.5! text-sm! font-medium! text-primary-foreground!',
          cancelButton: 'h-7! max-sm:h-10! rounded-md! bg-muted! px-2.5! text-sm! text-foreground!',
          closeButton: 'border-border! bg-popover! text-muted-foreground!',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
